<div
  (click)="onClose()"
  class="fixed inset-0 z-100 flex items-center justify-center p-4 bg-black/60 cursor-pointer"
>
  <div
    (click)="$event.stopPropagation()"
    class="relative w-full max-w-lg overflow-hidden bg-white rounded-2xl animate-fade-in-up cursor-default"
  >
    <div class="relative flex flex-col gap-5 items-center p-5 text-center z-10">
      <div
        class="relative flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg border border-gray-50"
      >
        <span class="text-5xl">
          {{ isHappy ? "😍" : "😔" }}
        </span>
      </div>

      <div>
        <h2 class="font-medium font-lg tracking-tight">
          {{ (isHappy ? "Feedback.Thanks" : "Feedback.Sorry") | translate }}
        </h2>

        <p class="text-[#6B7280] leading-relaxed mt-2">
          {{ (isHappy ? "Feedback.Glad" : "Feedback.Improve") | translate }}
        </p>
      </div>

      <div class="flex gap-2 stars-container">
        @for(star of [1, 2, 3, 4, 5];; track $index){

        <ng-container>
          <img
            [src]="
              star <= rating
                ? '/icons/starYellow.svg'
                : '/icons/emptyStarOrange.svg'
            "
            class="w-10 h-10 transition-transform duration-300 hover:scale-110"
            [alt]="
              (star <= rating ? 'Feedback.Filled_Star' : 'Feedback.Empty_Star')
                | translate
            "
          />
        </ng-container>
        }
      </div>

      <button
        (click)="onContinue()"
        class="bg-brand font-medium rounded-md px-4 py-3 w-full text-white"
      >
        {{ "Feedback.Continue" | translate }}
      </button>
    </div>
  </div>
</div>
